import { useState, useEffect } from "react";
import GridTable from "../../components/GridTable";
import { useDispatch, useSelector } from "react-redux";
import { deleteTemplate, getAllTemplates } from "../../api/templateApi";
import Swal from "sweetalert2";
import { formatDateToDDMMYYYY } from "../../uitls/Utils";
import {
  getTemplates,
  
  templateState as templateSliceState,
} from "./templateSlice";
import { getAllDepartment } from "../../api/departmentApi";
import { getDepartment } from "../department/departmentSlice";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/Loader";

const Template = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const stateOfTemplate = useSelector(templateSliceState);
 
  const [rows, setRows] = useState([]);
  const templates = useSelector(getTemplates);
  const allDepartments = useSelector(getDepartment);

  useEffect(() => {
    dispatch(getAllDepartment());
    dispatch(getAllTemplates());
  }, [dispatch]);

 
  useEffect(() => {
    if (Array.isArray(templates)) {
      // Sort templates by createdDate descending (newest first)
      const sortedTemplates = [...templates].sort((a, b) => {
        const dateA = new Date(a.createdDate || 0);
        const dateB = new Date(b.createdDate || 0);
        return dateB - dateA; // Descending order (newest first)
      });
      
      const formattedRows = sortedTemplates.map((template, index) => ({
        ...template,
        index: index + 1,
        businessUnit: allDepartments?.find(
          (department) => department?.id === template?.businessUnit
        )?.departmentName,
        templateTitle: template?.templateTitle,
        createdDate: formatDateToDDMMYYYY(template.createdDate),
        updatedDate: formatDateToDDMMYYYY(template.updatedDate),
        assignedUserCount: template?.assignedUserCount,
      }));
      setRows(formattedRows);
    }
  }, [templates, allDepartments]);

  const columns = [
    {
      field: "businessUnit",
      headerName: "Business Unit",
      width: 200,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "templateTitle",
      headerName: "Template Name",
      width: 200,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "assignedUserCount",
      headerName: "Assigned Users",
      width: 200,
      headerClassName: "super-app-theme--header",
    },
    
    {
      field: "updatedDate",
      headerName: "Updated Date",
      width: 200,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "createdDate",
      headerName: "Created Date",
      width: 200,
      headerClassName: "super-app-theme--header",
    },
  ];

 


  const handleDelete = (id) => {
    Swal.fire({
      titleText: "Delete Template ?",
      text: "Are you sure want to delete this template?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc2626", // Red for destructive action
      cancelButtonColor: "#3C50E0", // Primary color for cancel
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
      customClass: {
        popup: "custom-swal-width", // Custom width of the popup
        icon: "custom-swal-icon", // Custom icon size
        title: "custom-swal-title", // Custom title size
        content: "custom-swal-content", // Custom content (text) size
      },
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteTemplate(id))
          .unwrap()
          .then(() => {
          })
          .catch((error) => {
            console.error("Failed to delete template:", error);
            Swal.fire({
              title: "Error!",
              text: "Failed to delete template. Please try again.",
              icon: "error",
              confirmButtonColor: "#3C50E0",
              customClass: {
                popup: "custom-swal-width",
                icon: "custom-swal-icon",
                title: "custom-swal-title",
                content: "custom-swal-content",
              },
            });
          });
      }
    });
  };

  const onClickAction = (actionType, row, id) => {
    if (actionType === "EDIT") {
      navigate("/admin/template/add-update?id=" + id + "&action=" + actionType);
    } else if (actionType === "DELETE") {
      handleDelete(id);
    } else if (actionType === "VIEW") {
      navigate("/admin/template/add-update?id=" + id + "&action=" + actionType);
    }
  };

  return (
    <div className="pt-4 md:pt-6 2xl:pt-10 w-full px-4 md:px-6 lg:px-8">
      {stateOfTemplate?.loading && <Loader />}
      <GridTable
        onClickAction={onClickAction}
        actions={["DELETE", "EDIT"]}
        rowData={rows}
        columnData={columns}
        toolTipName={"Create Template"}
        onClickAdd={() => navigate("/admin/template/add-update")}
      />
    </div>
  );
};

export default Template;
